const blogData = {
  title: {
    mainTitle: "BLOGS",
    heading: "Latest Blogs",
  },
  blogs: [
    {
      id: 1,
      imageUrl: "/blogs/blog1.png",
      date: "24-04-2025",
      category: "Solar Energy",
      title: "7 Common Myths About Solar Panels—Busted!",
      description:
        "Think solar panels are unreliable or expensive? Let's bust the 7 most common myths and reveal the facts behind them.",
      blogDetails: {
        imageUrl: "/blogs/blog1.png",
        date: "24-04-2025",
        readTime: "8 min read",
        category: "Solar Energy",
        title: "7 Common Myths About Solar Panels—Busted!",
        content: {
          mainTitle: "Debunking the Most Common Solar Panel Myths",
          description: [
            {
              type: "text",
              content:
                "As solar energy continues to gain popularity, a lot of myths and misconceptions still surround it. If you're considering going solar but are hesitant because of things you've heard, this blog is for you.",
            },
            {
              type: "myth-fact",
              myth: "Solar panels don't work on cloudy days",
              fact: "While solar panels produce less energy on cloudy days, they still generate power. Modern solar technology is efficient enough to absorb diffuse sunlight, allowing systems to work even when it's overcast.",
            },
            {
              type: "myth-fact",
              myth: "Solar is too expensive",
              fact: "Thanks to government subsidies, tax benefits, and falling prices of solar equipment, going solar is more affordable than ever. Many financing options, including EMI and solar loans, make it accessible for homeowners and businesses alike.",
            },
            {
              type: "myth-fact",
              myth: "Solar panels require high maintenance",
              fact: "Solar systems are low-maintenance. Occasional cleaning and an annual inspection are usually enough to keep them running efficiently for 25+ years.",
            },
            {
              type: "myth-fact",
              myth: "You need a battery to use solar power",
              fact: "While batteries are great for backup, most residential solar systems are connected to the grid. This means you can use solar power during the day and draw from the grid at night—without the need for storage.",
            },
            {
              type: "myth-fact",
              myth: "Solar panels will damage my roof",
              fact: "Professional installation actually protects the roof areas beneath the panels from weather elements. Plus, panels can be removed without damage if necessary.",
            },
            {
              type: "myth-fact",
              myth: "Solar energy isn't reliable",
              fact: "With proper system sizing and net metering, solar energy can meet your daily needs reliably. Many users experience zero power cuts and significantly reduced electricity bills.",
            },
            {
              type: "myth-fact",
              myth: "Solar panels don't last long",
              fact: "Most solar panels come with 25-year performance warranties and can last even longer with minimal upkeep. The inverter may need replacement once in 10–15 years, but the system itself is built to last.",
            },
            {
              type: "conclusion",
              content:
                "Solar energy is a powerful, clean, and reliable source of electricity. Don't let myths hold you back from making a smart investment. If you still have questions, reach out to us—we're here to help you make the switch with confidence!",
            },
          ],
        },
      },
    },
    {
      id: 2,
      imageUrl: "/blogs/blog2.png",
      date: "24-04-2025",
      category: "Solar Energy",
      title: "Why 2025 is the Best Year to Go Solar in Nagpur",
      description:
        "Explore why 2025 is the perfect time for homeowners in Nagpur to invest in solar energy—from subsidies to savings and sustainability.",
      blogDetails: {
        imageUrl: "/blogs/blog2.png",
        date: "24-04-2025",
        readTime: "6 min read",
        category: "Solar Energy",
        title: "Why 2025 is the Best Year to Go Solar in Nagpur",
        content: {
          mainTitle: "Solar in Nagpur: Why 2025 is the Golden Year",
          description: [
            {
              heading: "Introduction",
              text: "Nagpur, known as the 'Orange City,' is not just rich in culture and heritage—it's also one of the sunniest cities in India. With rising electricity bills and growing environmental concerns, 2025 is shaping up to be the best year yet for homeowners in Nagpur to switch to solar energy. Here's why.",
            },
            {
              heading: "1. High Solar Potential in Nagpur",
              text: "Nagpur receives over 300 sunny days annually, making it ideal for solar power generation. Installing rooftop solar panels ensures you harness this abundant, clean energy right from your home.",
            },
            {
              heading: "2. Government Subsidies in 2025",
              text: "The Government of India, under its Rooftop Solar Programme Phase II, is offering subsidies of up to 40% for residential installations. This makes solar more affordable than ever before. Maharashtra state incentives further sweeten the deal.",
            },
            {
              heading: "3. Escalating Electricity Prices",
              text: "Electricity tariffs in Maharashtra have been on a steady rise. By going solar, you can drastically reduce or even eliminate your electricity bills, protecting yourself from future rate hikes.",
            },
            {
              heading: "4. Net Metering Benefits",
              text: "With the net metering policy in place, any excess electricity your solar system generates can be sent back to the grid—earning you credits and reducing your power bill even more.",
            },
            {
              heading: "5. Increase in Property Value",
              text: "Homes with solar installations are seen as more attractive and energy-efficient. A solar-powered home in Nagpur can see a significant bump in its market value.",
            },
            {
              heading: "6. Environmental Impact",
              text: "By switching to solar, you're not only saving money but also reducing your carbon footprint. A typical 3kW solar system can offset over 3 tons of CO₂ emissions annually—that's like planting over 130 trees every year!",
            },
            {
              heading: "Conclusion",
              text: "2025 presents a golden opportunity for homeowners in Nagpur to invest in solar energy. With high sunlight availability, attractive subsidies, and long-term savings, there's never been a better time to make the switch.",
            },
            {
              heading: "Need Help Going Solar?",
              text: "At Satyanam Solar, we specialize in rooftop solar installations in Nagpur. Contact us today for a free site visit and customized quote.",
            },
          ],
        },
      },
    },
    {
      id: 3,
      imageUrl: "/blogs/blog3.png", // You'll need to add this image
      date: "07-05-2025",
      category: "Solar Initiatives",
      title: "Empower Women, Empower India: Join the Satyanam Solar Eco Partner Movement",
      description:
        "Discover how women across India can lead the clean energy revolution through Satyanam Solar's Eco Partner Program.",
      blogDetails: {
        imageUrl: "/blogs/blog3.png",
        date: "07-05-2025",
        readTime: "4 min read",
        category: "Solar Initiatives",
        title: "Empower Women, Empower India: Join the Satyanam Solar Eco Partner Movement",
        content: {
          mainTitle: "Empower Women, Empower India: Join the Satyanam Solar Eco Partner Movement",
          description: [
            {
              type: "text",
              content: "Imagine a world where women across India are not just managing homes or offices but also leading the clean energy revolution, right from their communities."
            },
            {
              type: "text",
              content: "At Satyanam Solar, we believe that the future of India's green journey lies in the power of women. That's why we're inviting passionate, motivated, and socially driven women to become part of our Eco Partner Program—a flexible, income-generating, and purpose-led opportunity that puts you at the forefront of India's solar energy movement."
            },
            {
              heading: "🌟 What is the Eco Partner Program?",
              text: "The Eco Partner Program is Satyanam Solar's initiative to build a network of individuals who are passionate about renewable energy and want to help others switch to solar power, all while earning for every successful referral. But now, we're taking it further by empowering Indian women to lead this movement."
            },
            {
              type: "text",
              content: "Whether you're a homemaker, student, working professional, or someone looking for a side hustle, this program is designed to fit into your lifestyle. No technical knowledge? No problem! We'll train you and provide full support along the way."
            },
            {
              heading: "💪 Why This Is Your Moment?",
              text: "✅ Flexible Work, Real Earnings:  \n Say goodbye to rigid 9-to-5 routines. As an Eco Partner, you set your own schedule. Refer friends, neighbours, or businesses to Satyanam Solar and earn a commission based on the solar system installed. The bigger the project, the higher the reward."
            },
            {
              type: "text",
              content: "✅ Empower Your Community\nBe a changemaker! You'll be helping families reduce electricity bills, guiding them to government solar subsidies, and contributing to a greener, cleaner India. You're not just earning—you're creating real impact."
            },
            {
              type: "text",
              content: "✅ Skills That Shine\nYou'll gain knowledge in solar technology, green energy policies, sales communication, and more. These are skills that can open new doors, personally and professionally."
            },
            {
              heading: "👩‍🦰 Why Focus on Women?",
              text: "Because women are powerful communicators, trusted community members, and natural educators. At Satyanam, we're creating opportunities for women to:\n• Earn money from home through solar referrals\n• Educate their networks about sustainable living\n• Break traditional barriers in the energy space\nWe believe in women-led climate action. This isn't just business—it's a mission."
            },
            {
              heading: "👩‍👧‍👦 Who Can Join?",
              text: "Our solar family is open to:\n• Homemakers looking to contribute financially\n• Students eager for experience and extra income\n• Teachers, community leaders & social influencers who want to spread awareness\n• Freelancers & professionals seeking a flexible income stream\n• Retired women who still want to make a difference\nIf you have a voice, a phone, and a will to empower—you're already qualified."
            },
            {
              heading: "🚀 How It Works",
              text: "• Apply Online: at SatyanamSolar.com\n• Get Trained: in solar basics, how to talk to customers, and how to earn\n• Start Referring: solar leads through WhatsApp, calls, or conversations\n• Track and Earn: get paid for every successful installation"
            },
            {
              heading: "🌞 Why Satyanam Solar?",
              text: "We're one of Nagpur's most trusted solar companies, known for:\n• Transparent pricing & fast installations\n• Exceptional after-sales service\n• Quarterly & Annual system checkups & dedicated support\n• WhatsApp customer support for instant help\nWhen you refer Satyanam, you're referring reliability, quality, and community-first service."
            },
            {
              heading: "💫 Real Women. Real Change.",
              text: "Let's flip the script. Let's create a network of solar-powered women who are confident, capable, and committed to changing India's energy story—one rooftop at a time.\nIf you're ready to earn, learn, and lead, we're ready to welcome you."
            },
            {
              type: "reason",
              reason:"link",
              content: "Be the reason someone goes solar. Be the woman who lights up homes and futures.\nBecome an Eco Partner »"
            }
          ]
        }
      }
    },
    {
      id: 4,
      imageUrl: "/blogs/blog4.png", // You'll need to add this image
      date: "06-06-2025",
      category: "Solar Maintenance",
      title: "Solar Panels deserve love too – How Satyanam Solar keeps your home Shining Bright",
      description:
        "Learn why solar panel maintenance is crucial and how Satyanam Solar ensures your system performs optimally for years.",
      blogDetails: {
        imageUrl: "/blogs/blog4.png",
        date: "06-06-2025",
        readTime: "5 min read",
        category: "Solar Maintenance",
        title: "Solar Panels deserve love too – How Satyanam Solar keeps your home Shining Bright",
        content: {
          mainTitle: "Solar Panels deserve love too – How Satyanam Solar keeps your home Shining Bright",
          description: [
            {
              type: "text",
              content: "Most of us imagine a sunny rooftop, shining panels, and reduced power costs when we think about solar energy. However, we sometimes ignore the fact that solar panels require maintenance just like any other essential element in your house. Our goal at Satyanam Solar is to maintain your clean energy journey bright and constant, and we think that solar maintenance is more than simply a service."
            },
            {
              heading: "Why Solar Maintenance Is Crucial",
              text: "Although solar panels are intended to last for least 25 years, they may operate poorly or develop problems that go undiagnosed if they are not regularly maintained. Weather damage, dirt, dust, and bird droppings can all lower the effectiveness of your panel. This becomes much more important in India, particularly in regions that have regular monsoons or high dust levels.\nLike buying a new car and never changing the oil, neglecting maintenance results in decreased performance and ultimately higher costs."
            },
            {
              heading: "What Does Solar Maintenance Involve?",
              text: "At Satyanam Solar, we follow a comprehensive solar maintenance checklist that includes:\n• Panel cleaning: Removing dust, leaves, and other pollutants that block sunlight.\n• Wiring and connections check: Ensuring no loose wires or wear that could affect output or cause safety issues.\n• Inverter inspection: The inverter is the heart of your solar system. We monitor its status and output.\n• Structural support check: Especially important for rooftop or terrace installations in high-wind or rain-prone zones.\n• Performance tracking: Monitoring your generation and comparing it to expected output to flag any drops early.\nBy maintaining your system regularly, you can increase solar output by 10–30% and extend the life of your panels."
            },
            {
              heading: "Why Choose Satyanam Solar?",
              text: "We aren't just solar installers—we're your long-term partners. Our dedication to environmental sustainability means we have the same stake in the efficiency of your system as you have. What sets our solar maintenance service special is:\n• Scheduled Service Reminders: Your solar checkup is never missed.\n• Expert Technicians: Our team is trained specifically in solar troubleshooting.\n• Transparent Reporting: Following each service, you will receive a thorough health report.\n• Quick Support: We guarantee prompt resolution of any issue by prioritising our customers.\nWe think that in order to keep your house shining – solar care should be easy, inexpensive and stress free."
            },
            {
              heading: "Sustainable Homes Start with Care",
              text: "Maintaining your solar system isn't just about power it's about sustainability, savings, and safety. At Satyanam Solar, we aim to create a culture where homes across India treat solar systems like the valuable assets they are.\nBecause let's face it solar panels deserve love too. 💛"
            }
          ]
        }
      }
    }
  ],
};

export { blogData };